import React from 'react';
import { Box, Typography } from '@mui/material';
import { theme } from 'theme';
import { colorLightGrey } from 'customColors';

interface TabButtonProps {
  label: string;
  /** @deprecated. This field (value) is not being used and can be removed */
  value?: string;
  selected: boolean;
  onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({
  label,
  selected,
  onClick,
}) => (
  <Box
    onClick={onClick}
    sx={{
      cursor: 'pointer',
      border: selected
        ? `1px solid ${theme.palette.common.white}`
        : `1px solid ${colorLightGrey}`,
      backgroundColor: selected ? theme.palette.primary.main : 'transparent',
      color: selected ? theme.palette.common.white : theme.palette.primary.main,
      height: '43px',
      padding: '0 12px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 8,
      minWidth: '120px',
    }}
  >
    <Typography fontSize={12} fontWeight={400}>
      {label}
    </Typography>
  </Box>
);
